export default "__VITE_ASSET__DfDh82BW__"